/* @flow */
import * as React from 'react';

const Appliances = props => (
  <svg
    width={112}
    height={93}
    viewBox="0 0 112 93"
    fillRule="evenodd"
    stroke="#1C1F34"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      points="1.5 85.469 46.265 85.469 46.265 1.5 1.5 1.5"
    />
    <polygon strokeWidth={3} points="1.5 85.469 46.265 85.469 46.265 1.5 1.5 1.5" />
    <polygon strokeWidth={3} points="5.5 91.376 9.658 91.376 10.658 89.376 4.5 89.376" />
    <path strokeWidth={1.5} d="M1.5,31.335 L46.265,31.335" />
    <path
      strokeWidth={1.5}
      d="M9.521,37.668 L8.997,37.668 C7.909,37.668 7.027,38.55 7.027,39.637 L7.027,50.506 C7.027,51.593 7.909,52.475 8.997,52.475 L9.521,52.475"
    />
    <path
      strokeWidth={1.5}
      d="M9.521,9.014 L8.997,9.014 C7.909,9.014 7.027,9.896 7.027,10.983 L7.027,21.852 C7.027,22.939 7.909,23.821 8.997,23.821 L9.521,23.821"
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      points="2.5 89.376 45.265 89.376 45.265 85.469 2.5 85.469"
    />
    <polygon strokeWidth={3} points="2.5 89.376 45.265 89.376 45.265 85.469 2.5 85.469" />
    <polygon strokeWidth={3} points="38.106 91.376 42.078 91.376 43.034 89.465 37.151 89.465" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#9EA1AE"
      points="59.453 85.469 110.218 85.469 110.218 49.553 59.453 49.553"
    />
    <polygon
      stroke="#3A427C"
      strokeWidth={3}
      points="59.453 85.469 110.218 85.469 110.218 49.553 59.453 49.553"
    />
    <path stroke="#FFFFFF" strokeWidth={1.5} d="M109.689,68.833 L94.082,84.44" />
    <path stroke="#FFFFFF" strokeWidth={1.5} d="M94.214,78.308 L88.083,84.439" />
    <polygon strokeWidth={3} points="59.453 85.469 110.218 85.469 110.218 49.553 59.453 49.553" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      points="59.453 49.553 110.218 49.553 110.218 36.797 59.453 36.797"
    />
    <polygon strokeWidth={3} points="59.453 49.553 110.218 49.553 110.218 36.797 59.453 36.797" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#E8EBF7"
      points="105.397 27.049 64.274 27.049 61.363 36.797 108.308 36.797"
    />
    <polygon strokeWidth={3} points="105.397 27.049 64.274 27.049 61.363 36.797 108.308 36.797" />
    <polygon strokeWidth={3} points="63.276 91.376 67.434 91.376 68.434 89.376 62.276 89.376" />
    <polygon strokeWidth={3} points="102.425 91.376 106.397 91.376 107.353 89.465 101.47 89.465" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#DEDEDE"
      points="60.408 89.466 109.263 89.466 109.263 85.469 60.408 85.469"
    />
    <polygon strokeWidth={3} points="60.408 89.466 109.263 89.466 109.263 85.469 60.408 85.469" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#1C1F34"
      d="M71.05,43.484 C71.05,42.343 70.125,41.419 68.985,41.419 C67.844,41.419 66.919,42.343 66.919,43.484 C66.919,44.625 67.844,45.549 68.985,45.549 C70.125,45.549 71.05,44.625 71.05,43.484"
    />
    <path strokeWidth={1.5} d="M68.985,43.484 L68.985,41.441" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#1C1F34"
      d="M81.617,43.484 C81.617,42.343 80.692,41.419 79.552,41.419 C78.411,41.419 77.486,42.343 77.486,43.484 C77.486,44.625 78.411,45.549 79.552,45.549 C80.692,45.549 81.617,44.625 81.617,43.484"
    />
    <path strokeWidth={1.5} d="M79.552,43.484 L79.552,41.441" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#1C1F34"
      d="M92.185,43.484 C92.185,42.343 91.26,41.419 90.12,41.419 C88.979,41.419 88.054,42.343 88.054,43.484 C88.054,44.625 88.979,45.549 90.12,45.549 C91.26,45.549 92.185,44.625 92.185,43.484"
    />
    <path strokeWidth={1.5} d="M90.119,43.484 L90.119,41.441" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#1C1F34"
      d="M102.752,43.484 C102.752,42.343 101.827,41.419 100.687,41.419 C99.546,41.419 98.621,42.343 98.621,43.484 C98.621,44.625 99.546,45.549 100.687,45.549 C101.827,45.549 102.752,44.625 102.752,43.484"
    />
    <path strokeWidth={1.5} d="M100.687,43.484 L100.687,41.441" />
    <path
      strokeWidth={1.5}
      d="M101.505,35.856 C101.505,35.064 100.863,34.422 100.071,34.422 L92.841,34.422 C92.049,34.422 91.407,35.064 91.407,35.856"
    />
    <path
      strokeWidth={1.5}
      d="M78.265,35.856 C78.265,35.064 77.623,34.422 76.831,34.422 L69.601,34.422 C68.809,34.422 68.167,35.064 68.167,35.856"
    />
  </svg>
);

export default Appliances;



// WEBPACK FOOTER //
// ./src/assets/images/icons/appliances.js